/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editInformation.vue?vue&type=template&id=bb915a3a&scoped=true"
import script from "./editInformation.vue?vue&type=script&lang=js"
export * from "./editInformation.vue?vue&type=script&lang=js"
import style0 from "./editInformation.vue?vue&type=style&index=0&id=bb915a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb915a3a",
  null
  
)

export default component.exports